import MaterialTable from "material-table";
import { Button } from "@material-ui/core";
import { tableIcons } from "../../tableIcons";
import StatusButton from "./StatusButton";
import CustomTable from "../table";

export default function CancelledTable({ data }) {
  const columns = [
    {
      title: "Order id",
      dataIndex: "orderId",
    },
    {
      title: "Subscription",
      dataIndex: "subscriptionName",
    },
    {
      title: "Customer",
      dataIndex: "customerName",
    },
    // {
    //   title: "ITEMS",
    //   dataIndex: "totalItems",
    // },
    {
      title: "Total",
      dataIndex: "totalAmount",
    },
    {
      title: "Start Date",
      dataIndex: "subscriptionStartDate",
    },
    {
      title: "End Date",
      dataIndex: "subscriptionEndDate",
    },
    // {
    //   title: "LAST ORDERED",
    //   dataIndex: "lastOrdered",
    // },
    {
      title: "Next Payment",
      dataIndex: "subscriptionRenewalDate",
    },
    {
      title: "Status",
      render: (rowData) => {
        return (
          <>
            <div>
              <StatusButton status={rowData.subscriptionStatus}>
                {rowData.subscriptionStatus}
              </StatusButton>
            </div>
            {/* <button
              style={{
                color: "#5194C6",
                border: "0",
                background: "transparent",
                fontSize: "0.75rem",
              }}
            >
              Suspend
            </button>{" "}
            |{" "}
            <button
              style={{
                color: "#5194C6",
                border: "0",
                background: "transparent",
                fontSize: "0.75rem",
              }}
              variant="text"
            >
              Cancel
            </button> */}
          </>
        );
      },
    },
    // {
    //   title: "INVOICE",
    //   field: "invoice",
    //   render: (rowData) => {
    //     return <Button variant="text">View Invoice</Button>;
    //   },
    // },
  ];
  return (
    <CustomTable
      columns={columns}
      title="Cancelled Subscriptions"
      data={data}
    />
  );
}
